import Card from "@mui/material/Card"
import StackedLineChart from '@mui/icons-material/StackedLineChart';
import { Summary } from "../../interface/Summary";
import Skeleton from "@mui/material/Skeleton";
import { User } from "../../interface/User";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { alpha, useTheme } from "@mui/material/styles";
import { dashboardMutedTextSx, getDashboardPanelSx } from "./dashboardStyles";

interface TotalAssetsProps
{
  user: User
  loading: boolean
  summary: Summary | undefined
}


export const TotalAssets = ({ loading, summary, user }: TotalAssetsProps) =>
{
  const theme = useTheme()

  return (
    <Card sx={{ ...getDashboardPanelSx(theme, 118), p: 2.5 }} elevation={0}>
    
    { loading ? <>

      <Skeleton height={30} width={30} variant="circular" /> 
      <Skeleton height={20} width="50%" sx={{ mt: 1 }} /> 
      <Skeleton height={34} width="70%" /> 

    </>
   
    : <>
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ position: "relative", zIndex: 1 }}>
      <Box>
        <Typography variant="overline" sx={{ letterSpacing: 1.4, ...dashboardMutedTextSx(theme) }}>
          Asset Net Worth
        </Typography>
        <Typography sx={{ fontSize: 28, lineHeight: 1.1, mt: 0.75 }}>
          {summary && `$${summary?.totalAssets.toFixed(2)} ${user.fundingCurrency}`}
        </Typography>
      </Box>
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: "10px",
          display: "grid",
          placeItems: "center",
          backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.16 : 0.12),
          color: theme.palette.primary.main,
        }}
      >
        <StackedLineChart fontSize="large"/>
      </Box>
    </Stack>

    </>}
  </Card>
  )
}
